import * as request from '../../request'
import * as serializers from './serializers'

export const getTimelineList = async (options) => {
  try {
    const res = await request.get(`v1/timelines?${options || ''}`)

    const { metadata, data } = serializers.common(res)

    return {
      data: serializers.timelineList(data),
      pagination: serializers.timelinePagination(metadata)
    }
  } catch (err) {
    return Promise.reject(err)
  }
}

// eslint-disable-next-line import/prefer-default-export
export const postInteration = async (data) => {
  try {
    await request.post('v1/timelines/events', data)

    return true
  } catch (err) {
    return Promise.reject(err)
  }
}
